import { render, staticRenderFns } from "./ShopifyInstall.pug?vue&type=template&id=1bc6a03e&lang=pug&external"
import script from "./ShopifyInstall.js?vue&type=script&lang=js&external"
export * from "./ShopifyInstall.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports